import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './lib/validate.js'
import './assets/css/public.css'
import '@/assets/js/highlight.pack'
import '@/assets/css/atom-one-dark-reasonable.css'

Vue.config.productionTip = false
Vue.directive('highlight', function (el) {
  let blocks = el.querySelectorAll('pre code')
  blocks.forEach((block) => {
    window.hljs.highlightBlock(block)
  })
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
